import { render, staticRenderFns } from "./Nofication.vue?vue&type=template&id=5ddb2ab5&"
import script from "./Nofication.vue?vue&type=script&lang=js&"
export * from "./Nofication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports